export default "__VITE_ASSET__6363c2ae__"